/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SInputs */

const en_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const es_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const fr_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const de_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const ja_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const zh_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const ar_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صغير (S)`)
};

const id_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const it_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const ru_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const pt_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P`)
};

const ko_val_s = /** @type {(inputs: Val_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

/**
* | output |
* | --- |
* | "S" |
*
* @param {Val_SInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_s = /** @type {((inputs?: Val_SInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_s(inputs)
	if (locale === "es") return es_val_s(inputs)
	if (locale === "fr") return fr_val_s(inputs)
	if (locale === "de") return de_val_s(inputs)
	if (locale === "ja") return ja_val_s(inputs)
	if (locale === "zh") return zh_val_s(inputs)
	if (locale === "ar") return ar_val_s(inputs)
	if (locale === "id") return id_val_s(inputs)
	if (locale === "it") return it_val_s(inputs)
	if (locale === "ru") return ru_val_s(inputs)
	if (locale === "pt") return pt_val_s(inputs)
	return ko_val_s(inputs)
});